<template>
<v-img :width="`${width}px`" :src="src" ></v-img>
</template>

<script>
export default {
  name: "TcnFileIcon",
  props: {
    fileName: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: '24'
    }
  },
  data() {
    return {
      src: null
    }
  },
  mounted() {
    try {
      this.src = require(`./fileIcon/${this.getAttachmentMediaType(this.fileName)}.png`)
    } catch (e) {
      this.src = require(`./fileIcon/blank.png`)
    }


  },
  methods: {
    getAttachmentMediaType(name) {
      return name != null ? name.split(".").pop().toLowerCase() : "blank"
    },
  }

}
</script>

<style scoped>

</style>
